//#region redux
import { boardMembersDataSnoozed } from "store/actions/boardMembersDataActions";
import { useDispatch } from "react-redux";
//#endregion
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
//#endregion
import useSnoozeAction from "components/common/useSnoozeAction";
import { LocalizationHelperInstance } from "utils/helpers";

function useUpdateBoardMembersDataSnoozeAction(id: number | string, onActionSuccess: (id: number | string) => void) {
  const dispatch = useDispatch();

  const onSnoozeUpdateBoardMembersDataSuccess = () => {
    dispatch(boardMembersDataSnoozed(0));
    onActionSuccess(0);
  };

  const { snoozeAction } = useSnoozeAction(
    id,
    WintSuperkollAPIModel.TodoType.UpdateNewBoardMembersData,
    onSnoozeUpdateBoardMembersDataSuccess,
    LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ContactDetails)
  );

  return snoozeAction;
}

export default useUpdateBoardMembersDataSnoozeAction;
